export default class LockService{
  static getId(reference){
    if(!reference){
      return null;
    }

    return `${reference.type}_${reference.id}`;
  }

  static saveLock(reference, token){
    const id = this.getId(reference);
    if(!id){
      return;
    }

    const key = `LOCK_${id}`;
    window.sessionStorage.setItem(key, token);
  }

  static removeLock(reference){
    const id = this.getId(reference);
    if(!id){
      return;
    }

    const key = `LOCK_${id}`;
    window.sessionStorage.removeItem(key);
  }

  static getLock(reference){
    const id = this.getId(reference);
    if(!id){
      return null;
    }

    const key = `LOCK_${id}`;
    return window.sessionStorage.getItem(key);
  }

  static hasLock(reference){
    const id = this.getId(reference);
    if(!id){
      return null;
    }

    const key = `LOCK_${id}`;
    return window.sessionStorage.getItem(key) != null;
  }
}